import { JsonProperty, ObjectMapper } from 'json-object-mapper';

export class RecruitCompanyBenefitItemModel {
    @JsonProperty()
    companyRootId: string | null = null;
  
    @JsonProperty()
    benefit: string | null = null;

    static create(input: any): RecruitCompanyBenefitItemModel {
        return ObjectMapper.deserialize<RecruitCompanyBenefitItemModel>(RecruitCompanyBenefitItemModel, input);
    }
  }